import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { IAffiliateAutoApproveResponse } from '@modules/general-settings/submodules/auto-approve/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import {
  ADMIN_GENERAL_SETTINGS_AUTO_APPROVE_PERMISSIONS,
  SETTINGS_AUTO_APPROVE_LIST_QUERY_KEY,
  SETTINGS_AUTO_APPROVE_LIST_URL,
} from '@modules/general-settings/submodules/auto-approve/constants';

export default function useSettingsAutoApproveListQuery(): IContextQueryResult<IAffiliateAutoApproveResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IAffiliateAutoApproveResponse>({
    queryKey: [SETTINGS_AUTO_APPROVE_LIST_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet(SETTINGS_AUTO_APPROVE_LIST_URL, {
      signal,
      permission: ADMIN_GENERAL_SETTINGS_AUTO_APPROVE_PERMISSIONS.AUTOAPPROVELOCALES_SHOW,
    }),
  });
}
